/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import PropTypes from 'prop-types';

// Component imports
import { Checkbox, Input, Radio, Select, Slider, Switch } from 'antd';

// Misc imports
import { INPUT_ELEMENT_TYPES } from '../../../../constants/llmConfiguration';
import CustomInputNumber from '../CustomInputNumber';

const strategyPropTypes = {
  field: PropTypes.shape({
    type: PropTypes.string,
    elementType: PropTypes.string,
    options: PropTypes.array,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    defaultValue: PropTypes.any
  }).isRequired,
  props: PropTypes.object,
  theme: PropTypes.shape({
    borderRadiusBase: PropTypes.string
  })
};

export const NumberInputStrategy = ({ field, props, theme }) => {
  const { elementType, min, max, step, defaultValue } = field;
  const { borderRadiusBase } = theme;

  if (elementType === INPUT_ELEMENT_TYPES.SLIDER) {
    return (
      <Slider
        {...props}
        min={min}
        max={max}
        className="custom-slider display-value"
        marks={{
          [min]: min,
          [max]: max,
          ...(defaultValue && defaultValue !== min && defaultValue !== max ? { [defaultValue]: 'Default' } : {})
        }}
        step={step}
        handleStyle={{ borderRadius: borderRadiusBase }}
        tooltip={{ open: false }}
      />
    );
  }
  return (
    <CustomInputNumber
      {...props}
      min={min}
      max={max}
      step={step}
      style={{ width: '100px' }}
    />
  );
};
NumberInputStrategy.propTypes = strategyPropTypes;

export const BooleanInputStrategy = ({ field, props }) => {
  const { elementType } = field;

  if (elementType === INPUT_ELEMENT_TYPES.SWITCH) {
    return <Switch {...props} />;
  }
  return <Checkbox {...props} />;
};
BooleanInputStrategy.propTypes = strategyPropTypes;

export const StringInputStrategy = ({ field, props }) => {
  const { elementType, options } = field;
  const hasOptions = options && options.length > 0;

  if (hasOptions) {
    if (elementType === INPUT_ELEMENT_TYPES.RADIO_BUTTON || elementType === INPUT_ELEMENT_TYPES.RADIO_GROUP) {
      return (
        <Radio.Group
          {...props}
          optionType={elementType === INPUT_ELEMENT_TYPES.RADIO_BUTTON ? 'button' : 'default'}
          className={elementType === INPUT_ELEMENT_TYPES.RADIO_BUTTON ? 'custom-radio-button' : 'd-flex flex-column'}
          buttonStyle="solid"
          options={options}
        />
      );
    }
    return (
      <Select
        {...props}
        options={options.map(value => ({ value, label: value }))}
      />
    );
  }

  return <Input {...props} />;
};
StringInputStrategy.propTypes = strategyPropTypes;

export const DefaultInputStrategy = ({ props }) => <Input {...props} />;

DefaultInputStrategy.propTypes = {
  props: PropTypes.object
};
